import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import { Typography } from '@material-ui/core';
import SquareIcon from '@material-ui/icons/StopRounded';
import { useStyle } from './useStyle';

const ArticleParser = ({ content, headerMark = true, className = '' }) => {
	const classes = useStyle();
	const options = {
		replace: ({ name, children, attribs }) => {
			if (!attribs) return;
			if (name === 'a') return <span>{domToReact(children, options)}</span>;
			if (['h1', 'h2'].includes(name))
				return (
					<Typography variant={name}>
						{headerMark && <SquareIcon className={classes.square} />}
						{domToReact(children, options)}
					</Typography>
				);
		},
	};
	return <div className={[classes.root, className].join(' ')}>{parse(content, options)}</div>;
};

export default ArticleParser;
